export const scrollIntoView = (element, offset) => {
  const elementPosition = element.offsetTop;
  const offsetPosition = elementPosition - offset;
  console.log("scrollIntoView", offset, elementPosition, offsetPosition);
  window.scrollTo({
    top: offsetPosition,
    behavior: "smooth",
  });
};
